<template>
  <transition name="fade">
    <div class="phrase-overlay" v-if="create_list" @click.self="close()">
      <div class="create-phrase-wrap w-600">
        <div class="list-create">
          <div class="newmessage-title">
            {{
              type == "add"
                ? "新規リストにインフルエンサーを追加"
                : type == "change"
                ? "「" + target_list_name + "」のリスト名変更"
                : type == "create"
                ? "新規リスト作成"
                : type == "change_report"
                ? "「" + target_list_name + "」のレポート名変更"
                : ""
            }}
            <div class="flex-space"></div>
            <div class="newmessage-button" @click="close()">
              <font-awesome-icon :icon="['fal', 'times']" />
            </div>
          </div>
          <el-form
            :model="newlist"
            :rules="rules"
            ref="newlist"
            style="width:100%"
            @submit.native.prevent="type == 'change' ? changeListName() : type == 'create' || type == 'add' ? createList() : type == 'change_report' ? changeReportName() : ''"
          >
            <div class="list-create">
              <div class="list-create-box">
                <div class="list-create-name">{{ type == "change_report" ? "レポート名" : "リスト名" }}を入力してください</div>
                <el-form-item prop="list_name">
                  <el-input v-model="newlist.list_name" id="autoFocus"></el-input>
                </el-form-item>
              </div>
              <div class="list-create-box" v-if="type == 'create'">
                <div class="create-report-sns-wrap">
                  <div class="create-report-sns small" @click="newlist.sns_type = 'instagram'" :class="newlist.sns_type == 'instagram' ? 'active' : ''" v-if="search_influencer_instagram_enabled" >
                    <div class="create-list-check"><font-awesome-icon :icon="['fas', 'check-circle']" v-show="newlist.sns_type == 'instagram'" /></div>
                    <div>Instagram</div>
                    <img class="create-report-sns-image" src="../../assets/ig_icon.png" alt />
                  </div>
                  <div class="create-report-sns small right" @click="newlist.sns_type = 'youtube'" :class="newlist.sns_type == 'youtube' ? 'active' : ''" v-if="search_influencer_youtube_enabled">
                    <div class="create-list-check"><font-awesome-icon :icon="['fas', 'check-circle']" v-show="newlist.sns_type == 'youtube'" /></div>
                    <div>YouTube</div>
                    <img class="create-report-sns-image" src="../../assets/yt_icon.png" alt />
                  </div>
                  <div class="create-report-sns small right" @click="newlist.sns_type = 'tiktok'" :class="newlist.sns_type == 'tiktok' ? 'active' : ''" v-if="search_influencer_tiktok_enabled">
                    <div class="create-list-check"><font-awesome-icon :icon="['fas', 'check-circle']" v-show="newlist.sns_type == 'tiktok'" /></div>
                    <div>TikTok</div>
                    <img class="create-report-sns-image" src="../../assets/tt_icon.png" alt />
                  </div>
                  <div class="create-report-sns small right" @click="newlist.sns_type = 'twitter'" :class="newlist.sns_type == 'twitter' ? 'active' : ''" v-if="search_influencer_x_enabled">
                    <div class="create-list-check"><font-awesome-icon :icon="['fas', 'check-circle']" v-show="newlist.sns_type == 'twitter'" /></div>
                    <div>X</div>
                    <img class="create-report-sns-image" src="../../assets/tw_icon.png" alt />
                  </div>
                </div>
              </div>
              <div class="list-create-footer" style="align-items:flex-end">
                <div class="flex-column" style="gap:6px; min-height:37px; justify-content: center">
                  <div class="flex-row" v-if="(activate == 11 || activate >= 15) && (type == 'create' || type == 'add')">
                    <el-checkbox class="checkbox-show checkbox-small" v-model="assign">
                      自分をリスト担当メンバーに割り当てる
                    </el-checkbox>
                  </div>
                  <div class="flex-row" v-if="from_media_search">
                    <el-checkbox class="checkbox-show checkbox-small" v-model="add_comment_child" @change="changeAddComment()">
                      投稿URLをリスト内コメントに追加する
                    </el-checkbox>
                  </div>
                  
                  <!-- 他SNS媒体選択時のみ、SNSタイプ選択を表示 -->
                  <div class="flex-row" v-if="this.other_sns_type != ''" >
                    <div class="list-create-name" style="margin:10px 12px 0 0">選択したSNSタイプで登録</div>
                    <el-radio-group v-model="create_sns_type" size="mini" style="margin: 12px 0 0;">
                      <el-radio-button v-if="this.other_sns_type == 'instagram' || sns_type == 'instagram'" label="instagram">
                        <font-awesome-icon :icon="['fab', 'instagram']" style="margin-left:4px; font-size:16px" />
                      </el-radio-button>
                      <el-radio-button v-if="this.other_sns_type == 'youtube' || sns_type == 'youtube'" label="youtube">
                        <font-awesome-icon :icon="['fab', 'youtube']" style="margin-left:4px; font-size:16px" />
                      </el-radio-button>
                      <el-radio-button v-if="this.other_sns_type == 'tiktok' || sns_type == 'tiktok'" label="tiktok">
                        <font-awesome-icon :icon="['fab', 'tiktok']" style="margin-left:4px; font-size:16px" />
                      </el-radio-button>
                      <el-radio-button v-if="this.other_sns_type == 'twitter' || sns_type == 'twitter'" label="twitter">
                        <svg width="14" height="14" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="currentColor"/>
                        </svg>
                      </el-radio-button>
                    </el-radio-group>                  
                  </div>
                  
                </div>
                <div class="flex-space"></div>
                <el-button @click="close()">キャンセル</el-button>
                <el-button type="primary" native-type="submit" :disabled="loading || !newlist.list_name">
                  <div class="flex-row">
                    {{ type == "change" ? "リスト名変更" : type == "create" || type == "add" ? "リスト作成" : type == "change_report" ? "レポート名変更" : "" }}
                    <div class="loader--mini" v-show="loading"></div>
                  </div>
                </el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const root = process.env.VUE_APP_API;
const createListAPI = root + "/api/list/create_list";
const changeListAPI = root + "/api/list/change_list";
const changeReportAPI = root + "/api/report/change_report";

export default {
  name: "createList",
  props: {
    create_list: {
      type: Boolean,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    sns_type: {
      type: String,
      default: null,
    },
    target_list_name: {
      type: String,
      default: null,
    },
    target_list_id: {
      type: Number,
      default: null,
    },
    target_list_index: {
      type: Number,
      default: null,
    },
    from_media_search: {
      type: Boolean,
      default: false,
    },
    add_comment: {
      type: Boolean,
      default: false,
    },
    other_sns_type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      newlist: {
        list_name: "",
        sns_type: "instagram",
      },
      rules: {
        list_name: [
          {
            required: true,
            message: "リスト名を入力してください",
            trigger: "change",
          },
        ],
      },
      loading: false,
      assign: true,
      add_comment_child: false,
      create_sns_type: this.sns_type,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    activate() {
      return this.$store.state.activate;
    },
    list_sns_type() {
      return this.$store.state.list_sns_type;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    search_influencer_instagram_enabled() {
      return this.$store.state.service_plan.search_influencer_instagram_enabled;
    },
    search_influencer_youtube_enabled() {
      return this.$store.state.service_plan.search_influencer_youtube_enabled;
    },
    search_influencer_tiktok_enabled() {
      return this.$store.state.service_plan.search_influencer_tiktok_enabled;
    },
    search_influencer_x_enabled() {
      return this.$store.state.service_plan.search_influencer_x_enabled;
    },
  },
  methods: {
    createList() {
      this.$refs["newlist"].validate((valid) => {
        if (valid) {
          this.loading = true;
          var params = new URLSearchParams();
          params.append("list_name", this.newlist.list_name);
          
          // 別SNS媒体を選択時はそちらのタイプを優先
          if(this.create_sns_type !== null && (this.create_sns_type != this.newlist.sns_type)) {
            params.append("sns_type", this.create_sns_type);
          } else {
            params.append("sns_type", this.newlist.sns_type); 
          }          
          
          params.append("assign", this.activate == 11 || this.activate >= 15 ? this.assign : false);
          params.append("user_token", this.user_token);
          params.append("token", this.token);
          this.axios.post(createListAPI, params).then((response) => {
            if (response.data.status == "OK") {
              if (this.type == "add") {
                this.$emit("addInfluencer", response.data.list_id, this.newlist.list_name);
              } else {
                this.$message({
                  type: "success",
                  offset: 7,
                  showClose: true,
                  message: "「" + this.newlist.list_name + "」を作成しました",
                });
              }
              this.newlist.list_name = "";
              this.newlist.sns_type = "instagram";
              this.loading = false;
              this.close();
              setTimeout(() => {
                this.$emit("loadList");
              }, 300);
            } else {
              this.loading = false;
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: response.data.message,
              });
            }
          });
        } else {
          this.loading = false;
          this.$message.error("リスト名を入力してください");
        }
      });
    },
    changeListName() {
      this.loading = true;
      var params = new URLSearchParams();
      params.append("change_type", "name");
      params.append("list_name", this.newlist.list_name);
      params.append("list_id", this.target_list_id);
      params.append("token", this.token);
      this.axios.post(changeListAPI, params).then((response) => {
        if (response.data.status == "OK") {
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "「" + this.newlist.list_name + "」に変更しました",
          });
          this.$emit("changeListName", this.newlist.list_name, this.target_list_index);
          this.newlist.list_name = "";
          this.loading = false;
          this.close();
        } else {
          this.loading = false;
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: response.data.message,
          });
        }
      });
    },
    changeReportName() {
      this.loading = true;
      var params = new URLSearchParams();
      params.append("change_type", "name");
      params.append("report_name", this.newlist.list_name);
      params.append("report_id", this.target_list_id);
      params.append("token", this.token);
      this.axios.post(changeReportAPI, params).then(() => {
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: "「" + this.newlist.list_name + "」に変更しました",
        });
        this.$emit("changeReportName", this.newlist.list_name, this.target_list_index);
        this.newlist.list_name = "";
        this.loading = false;
        this.close();
      });
    },
    changeAddComment() {
      if (this.create_list == true) this.$emit("update:add_comment", this.add_comment_child);
    },
    close() {
      this.$emit("update:create_list", false);
    }
  },
  watch: {
    create_list() {
      if (this.create_list == true) {
        setTimeout(() => {
          document.getElementById("autoFocus").focus();
        }, 200);
      }
      if (this.type == "add") {
        this.newlist.sns_type = this.sns_type;
      } else if (this.type == "change" || this.type == "change_report") {
        this.newlist.list_name = this.target_list_name;
      } else if (this.list_sns_type == "master" || this.list_sns_type == "all") {
        this.newlist.sns_type = "instagram";
      } else {
        this.newlist.sns_type = this.list_sns_type;
      }

      if (this.from_media_search) this.add_comment_child = this.add_comment;
    },
    add_comment() {
      this.changeAddComment();
    },
    type() {
      if (this.type == "create") this.newlist.list_name = "";
    },
  },
};
</script>

<style></style>
